var module = angular.module('bbl.services.simpleshare');

module.factory('PeerDataChannel', ['pubsub', function(pubsub) {
  return function PeerDataChannel(conn, channelName) {
    var types = {
      CONNECTED: 'peer.data.connected',
      DISCONNECTED: 'peer.data.disconnected',
      ONMESSAGE: 'peer.data.onmessage',
    };

    PeerDataChannel.types = types;

    var peerCh = {};
    // var localData = {};
    var uniq = {};

    conn.createDataChannel(channelName)
      .on('channel:opened:'+channelName, register)
      .on('channel:closed:'+channelName, unRegister);

    function register(id, dc) {
      (peerCh[id] = dc).onmessage = function(evt) {
        var message = JSON.parse(evt.data);

        if (uniq[message.id]) {
          return;
        }

        uniq[message.id] = true;
        pubsub.pub(types.ONMESSAGE, message);
      };

      pubsub.pub(types.CONNECTED, {id: id, peer: dc});
    }

    function unRegister(id) {
      peerCh[id] = undefined;
      pubsub.pub(types.DISCONNECTED, conn.peers.get(id).data.user);
    }

    function send(data, peer) {
      var msg = JSON.stringify(angular.merge({
        id: conn.id + ':' + Date.now() + ':' + Math.random().toString().slice(2, 11),
        timestamp: Date.now(),
      }, typeof data === 'string' ? {data: data} : data));

      if(!peer) {
        conn.peers.keys()
          .filter(function(peer) { return !!peerCh[peer]; })
          .forEach(function(peer) {
            try {peerCh[peer].send(msg);} catch(e) {
              console.warn('peer invalid state, cant send message!');
            }
          });
      } else {
        peer.send(msg);
      }

      return msg;
    }

    return {
      send: send,
      sub: pubsub.sub.bind(pubsub),
    };
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/peer-data-channel.js
 ** module id = 221
 ** module chunks = 0
 **/